// extracted by mini-css-extract-plugin
export default {"languages":"languages-control_languages__uj3ci","languageTabs":"languages-control_languageTabs__nyGfb"};